import React from 'react';
import Optional from '../../../utils/optional';
import { translate } from '../../../i18n/I18nProvider';
import StatusCell from '../../../partials/statusCell/StatusCell';
import pickOptionsForStatusCell from '../../../partials/statusCell/actions/pickOptionsForStatusCell';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import {
  translateIdentifier,
  translateValue
} from '../actions/translateActions';

const DefaultDetailRow = ({
  label,
  value,
  classes,
  accountName,
  statusBox = false,
  dataKey,
  translateValues = true
}) => {
  const key = dataKey || label;
  let valueToDisplay = value;

  if (translateValues && key === 'action') {
    valueToDisplay = translateValue(value) || value;
  }

  if (translateValues && key === 'identifier') {
    valueToDisplay = translateIdentifier(value) || value;
  }

  if (key === 'account_reference') {
    valueToDisplay = Optional(accountName).or(valueToDisplay);
  }

  return (
    <div className={classes.innerRowContainer}>
      <div>{label}</div>
      <div className={classes.value}>
        {typeof valueToDisplay === 'boolean' ? (
          statusBox === true ? (
            <StatusCell
              alignRight={true}
              alignLeft={false}
              {...pickOptionsForStatusCell(
                STATUS_BOX_OPTIONS.TRUE_FALSE,
                valueToDisplay
              )}
            />
          ) : (
            translate(valueToDisplay.toString().toUpperCase())
          )
        ) : (
          valueToDisplay
        )}
      </div>
    </div>
  );
};

export default DefaultDetailRow;
